/** A non-null, non-array object, read by string key (e.g. parsed JSON or tool output). */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
